import React, { useEffect, useRef, useState } from "react";
import { Footer } from "../components/Footer";
import axios from "axios";

import down_arrow from '../../src/icon/down-arrow.svg';

const FAQ = () => {
  const DivRef = useRef(null);

  useEffect(() => {
    if (DivRef.current) {
      DivRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, []);

  return (
    <div className="mt-20">
      <div className="page-banner bannerFAQ" ref={DivRef}>
        <h4 className="banner-title">{/* Testimonials */}</h4>
      </div>
      <div className="my-20 w-full">
        <div className="w-[95%] md:w-[85%] mx-auto">
          <Accordion />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [items, setItems] = useState([]);

  const faq_api = process.env.REACT_APP_API_URL_FAQ;

  useEffect(() => {
    fetchFAQ();
  }, []);

  const fetchFAQ = async () => {
    const response = await axios.get(faq_api);
    const data = response.data;
    setItems(data);
    try {
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };
  const rotateArrow = (index) => {
    return activeIndex === index;
  };

  return (
    <div>
      <div className="accordion-fq ">
        {items.map((itemAcc, index) => (
          <div key={index} className="simple-accordion-item">
            <div
              className={`accordion-header-fq flex justify-between  items-start ${
                activeIndex === index ? "accordion-active" : ""
              }`}
              onClick={() => handleClick(index)}
            >
              <h3 className="text-2xl md:text-3xl leading-[36px] font-medium ">
                {itemAcc.question}
              </h3>
              <span
                className={`ml-2 transition-transform duration-200 transform  ${rotateArrow(
                  index
                ) && 'rotate-180'}`}
              >
                <div>
                  <img src={down_arrow} alt="" />
                </div>
              </span>
            </div>
            {activeIndex === index && (
              <div className="accordion-content">
                <p dangerouslySetInnerHTML={{__html:itemAcc.answer}}/>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
